import { render, staticRenderFns } from "./previewMaterialModal.vue?vue&type=template&id=1e5d50b0&scoped=true"
import script from "./previewMaterialModal.vue?vue&type=script&lang=js"
export * from "./previewMaterialModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5d50b0",
  null
  
)

export default component.exports